import { Chip, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { chargingStationStatusDisplay } from '../chargingStationStatusDisplay';
import { ChargingStationStatus } from '../chargingStationStatuses';

interface ChargingStationShadowStatusChipProps {
  shadowStatus: ChargingStationStatus;
}

export const ChargingStationShadowStatusChip: React.FC<
  ChargingStationShadowStatusChipProps
> = ({ shadowStatus }) => {
  const [t] = useTranslation('chargingStations');
  const theme = useTheme();

  return shadowStatus ? (
    <Chip
      label={t(shadowStatus, { context: 'status' })}
      sx={{
        backgroundColor:
          chargingStationStatusDisplay(theme)[shadowStatus].bgColor,
        color: chargingStationStatusDisplay(theme)[shadowStatus].color,
        fontWeight: 500,
      }}
    />
  ) : null;
};
